import React from 'react';
import { useHistory } from 'react-router-dom';

import PbxListItem from 'flow/components/ui-components/PbxListItem';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOwnUserHasCapability } from 'flow/selectors/ExtensionSelectors';
import { routes } from 'flow/types/routes';
import { Capabilities } from 'flow/utils/capability-utils';

type Props = {
    /** Whether the meetings list is open. */
    isOpen: boolean;
};

/** The fixed entry leading to the meetings list. It asks for itself whether
 *  this user has video, which decides its icon. */
const MeetingsListItem = ({ isOpen }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();

    const ownUserHasCapabilityVideo = useAppSelector((state) =>
        selectOwnUserHasCapability(state, Capabilities.VIDEO),
    );

    return (
        <div>
            <PbxListItem
                type={
                    ownUserHasCapabilityVideo ? 'conference' : 'conference_call'
                }
                title={i18next.t('meetings.title')}
                marking={isOpen ? 'pageOpen' : undefined}
                onClick={() => history.push(routes['messages.meetings'])}
            />
        </div>
    );
};

export default React.memo(MeetingsListItem);
